import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=24a24232&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=24a24232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a24232",
  null
  
)

export default component.exports